import { useRef, useState } from 'react'
import { queryClient } from '../../../../../App'
import { Mode } from '../NewServiceResultsDrawer'
import { ActiveOrder } from '../types/NewDrawers.types'

export const useServiceResultsState = (resetForm: () => void) => {
  const [serialNum, setSerialNum] = useState<string | null>(null)
  const [checked, setChecked] = useState(false)
  const [selectedServiceRequest, setSelectedServiceRequest] =
    useState<ActiveOrder | null>(null)
  const [openedAccordionIndex, setOpenedAccordionIndex] = useState(-2)
  const [mode, setMode] = useState<Mode>('default')
  const notifyRef = useRef(false)

  const resetState = () => {
    resetForm()
    setSerialNum('')
    setChecked(false)
    setSelectedServiceRequest(null)
    setOpenedAccordionIndex(-2)
    setMode('default')
    notifyRef.current = false
    setTimeout(
      () =>
        queryClient.invalidateQueries({ queryKey: ['check-serial-number'] }),
      0
    )
  }

  return {
    state: {
      serialNum,
      checked,
      selectedServiceRequest,
      openedAccordionIndex,
      mode,
      notifyRef,
    },
    setters: {
      setSerialNum,
      setChecked,
      setSelectedServiceRequest,
      setOpenedAccordionIndex,
      setMode,
    },
    resetState,
  }
}
